module.exports = __webpack_public_path__ + "img/IMG_0079_L.4258c08c.webp";